import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

/**
 * Ambient + directional lighting driven by graphicsSettings.shadowsEnabled.
 * Drop inside any R3F Canvas that should share consistent lighting behaviour.
 */
export const SceneLighting = () => {
    const shadowsEnabled = usePlacementStore(useShallow((state) => state.graphicsSettings.shadowsEnabled));

    return (
        <>
            <ambientLight intensity={shadowsEnabled ? 2 : 2.5} />
            <directionalLight
                castShadow={shadowsEnabled}
                intensity={shadowsEnabled ? 0 : 0.55}
                position={[8, 6, 14]}
                shadow-bias={-0.0005}
                shadow-camera-bottom={-20}
                shadow-camera-far={60}
                shadow-camera-left={-20}
                shadow-camera-near={0.5}
                shadow-camera-right={20}
                shadow-camera-top={20}
                shadow-mapSize-height={2048}
                shadow-mapSize-width={2048}
                visible={shadowsEnabled}
            />
        </>
    );
};
